/**
 * Non-hook localStorage utilities with safe JSON parse/stringify.
 * Use these in plain functions, class methods, or outside React hooks.
 * For React components, prefer usePersistedState hook instead.
 */

/**
 * Read a value from localStorage with safe JSON parsing.
 * Returns defaultValue if key doesn't exist or parsing fails.
 */
export function getLocalStorageItem<T>(key: string, defaultValue: T): T {
  try {
    const saved = localStorage.getItem(key);
    return saved !== null ? JSON.parse(saved) : defaultValue;
  } catch {
    return defaultValue;
  }
}

/**
 * Write a value to localStorage with safe JSON stringify.
 * Silently ignores errors (quota exceeded, private browsing, etc.).
 */
export function setLocalStorageItem<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Ignore localStorage errors (quota exceeded, private browsing, etc.)
  }
}
